import type { FormatDateOptions, IntlFormatters } from "react-intl";
import { mapToCopyFileCare } from "./mapToCopyFileCare";
import { mapToCopyFilePortal } from "./mapToCopyFilePortal";
import { mapToCopyFileShared } from "./mapToCopyFileShared";
import { mapToCopyFileWebshop } from "./mapToCopyFileWebshop";

export const mapToCopyFile = {
  shared: mapToCopyFileShared,
  care: mapToCopyFileCare,
  portal: mapToCopyFilePortal,
  webshop: mapToCopyFileWebshop,
};

export type TranslationFile = Record<string, unknown>;

export type CopyFileShared = ReturnType<(typeof mapToCopyFile)["shared"]>;
export type CopyFileCare = ReturnType<(typeof mapToCopyFile)["care"]>;
export type CopyFilePortal = ReturnType<(typeof mapToCopyFile)["portal"]>;
export type CopyFileWebshop = ReturnType<(typeof mapToCopyFile)["webshop"]>;
export type CopyKeyShared = KeyPaths<CopyFileShared>;
export type CopyKeyCare = KeyPaths<CopyFileCare>;
export type CopyKeyPortal = KeyPaths<CopyFilePortal>;
export type CopyKeyWebshop = KeyPaths<CopyFileWebshop>;
export type CopyKey = CopyKeyCare | CopyKeyPortal | CopyKeyShared | CopyKeyWebshop;

export type KeyPaths<T extends TranslationFile, Prefix extends string = ""> = {
  [K in keyof T]-?: T[K] extends TranslationFile
    ?
        | `${Prefix & string}${Prefix extends "" ? "" : "."}${K & string}`
        | KeyPaths<T[K], `${Prefix & string}${Prefix extends "" ? "" : "."}${K & string}`>
    : `${Prefix & string}${Prefix extends "" ? "" : "."}${K & string}`;
}[keyof T];

export type FormatMessageArgs = Parameters<IntlFormatters["formatMessage"]>;
export type SharedFormatMessage = (
  descriptor: FormatMessageArgs[0] & {
    id: CopyKeyShared;
  },
  values?: FormatMessageArgs[1],
  options?: FormatMessageArgs[2],
) => string;
export type SharedFormatDate = (
  this: void,
  value: Parameters<Intl.DateTimeFormat["format"]>[0] | string,
  opts?: FormatDateOptions,
) => string;
export type SharedFormatTime = (
  options: FormatTimeOptions & {
    hideSeconds?: boolean;
    hideColumn?: boolean;
  },
) => string;

export type FormatTimeOptions = {
  seconds?: number;
  minutes?: number;
  hours?: number;
  alwaysShowMinutes?: boolean;
  alwaysShowHours?: boolean;
}

export type TimeUnitId = "shared.units.seconds" | "shared.units.minutes" | "shared.units.hours";
